
define('app/purchases/paypal/paypalApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'app/purchases/paypal/views/paypalView',
	'module'
], function(
		$, 
		_, 
		Backbone,
		KnownUtil,
		PaypalView, 
		module){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		
		var paypalJSON = $.parseJSON(module.config().requestedPaypalJSON);
		
		var paypalView = new PaypalView({paypalJSON: paypalJSON});
		paypalView.render();
	};
	
	return {
		initialize: initialize
	};
});